import React, {lazy, useEffect} from 'react';
import Loadable from '../../../ui-component/Loadable';
import { List } from '@mui/material';
import {useDispatch, useSelector} from "react-redux";
import {pre, success} from "../../../_data/strings";
import {FETCH_CONFIG} from "../../../store/types";

const ItemSiteWeb = Loadable(lazy(() => import('./ItemSiteWeb')));

function Alternative() {
    const {data, state} = useSelector(({config}) => config);
    const dispatch = useDispatch();

    useEffect(() => {
        if (state === pre) {
            dispatch(FETCH_CONFIG);
        }
    }, [state, dispatch]);
    return (
        <List component='div' style={{
            paddingTop: '0', textAlign: 'center',
            top: 0, zIndex: 999999, background: '#121212'
        }}>
            {state === success && data.sites.map((site) => <ItemSiteWeb key={site.name} cdn={data.cdn} {...site} />)}
        </List>
);
}

export default Alternative;
